import { getSortByString } from '@nbirl/nbi-common-ui-libs';

import { useQueryParams } from '../../../shared/hooks';
import { ResourceList } from '../common/components';
import { DocumentsListState } from '../documents/models';
import { EmptyFavourites, FavouritesCount } from './components';
import { useFavouritesQuery } from './queries';

export const Favourites = () => {
  const [query, setQuery] = useQueryParams<DocumentsListState>({
    pageSize: 50,
    pageIndex: 0,
    sortBy: getSortByString({ id: 'name', desc: false }),
    search: '',
  });

  const { data, error, isLoading, refetch } = useFavouritesQuery();

  return (
    <ResourceList
      heading={<FavouritesCount />}
      isLoading={isLoading}
      error={error}
      list={data}
      totalElements={0}
      pageCount={0}
      query={query}
      emptyState={<EmptyFavourites />}
      onRefetch={refetch}
      onQueryChange={setQuery}
    />
  );
};
